<template>
  <div>
    <div v-if="hasAtLeastRoles" class="cursor-pointer">
      <vs-button v-if="withButton" size="medium" @click="downloadCSV">
        <div class="flex items-center">Download {{ dataDownloadedName }}</div>
      </vs-button>
      <div
        v-else
        class="text-xs text-primary cursor-pointer underline flex items-center"
        @click="downloadCSV"
      >
        <span>Download {{ dataDownloadedName }}</span>
        <feather-icon icon="DownloadIcon" class="w-4 ml-1"></feather-icon>
      </div>
    </div>
    <div
      v-else
      v-tooltip="tooltipContent"
      class="cursor-not-allowed"
      @mouseenter="logTooltipDownloadNotAllowedEvent"
    >
      <vs-button v-if="withButton" size="medium" disabled>
        <div class="flex items-center">Download historical values</div>
      </vs-button>
      <div v-else class="text-xs text-primary cursor-not-allowed underline flex items-center">
        <span>Download {{ dataDownloadedName }}</span>
        <feather-icon icon="DownloadIcon" class="w-4 ml-1"></feather-icon>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/compat/app";
import { json2csv } from "json-2-csv";
import moment from "moment";

import { hasAnyRoles } from "@/acl";
import { Role } from "@/acl/roles";
import { DOWNLOAD_DATA_EVENT, TOOLTIP_DISPLAYED_EVENT } from "@/assets/constants/analytics";
import axios from "@/http/axios";

export default {
  name: "DownloadAsCSV",
  props: {
    // URL to get the data to export to a csv
    url: {
      type: String,
    },
    // If no url provided, we use the data given in argument.
    data: {
      type: Array,
    },
    // Name of the CSV file
    name: {
      type: String,
      required: true,
    },
    dataDownloadedName: {
      type: String,
      default: "indicator",
    },
    fullPlanNameNeeded: {
      type: String,
      default: "Indicators",
    },
    neededPlans: {
      type: Array,
      default: () => [Role.indicator],
    },
    withButton: {
      type: Boolean,
      default: false,
    },
    extraParams: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    hasAtLeastRoles() {
      return hasAnyRoles([Role.admin, Role.superAdmin, Role.employee, ...this.neededPlans]);
    },
    tooltipContent() {
      return {
        content: `Contact us to get access to ${this.dataDownloadedName}.`,
        boundariesElement: "window",
      };
    },
  },
  methods: {
    logTooltipDownloadNotAllowedEvent() {
      this.$analytics.logEvent(TOOLTIP_DISPLAYED_EVENT, {
        tooltip: "download_not_allowed",
      });
    },
    dataToJsonDownload(data) {
      try {
        const csv = json2csv(data);
        const anchor = document.createElement("a");
        anchor.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
        anchor.target = "_blank";
        anchor.download = this.name.replace(/\s/g, "_").toLowerCase() + ".csv";
        anchor.click();
        this.$analytics.logEvent(DOWNLOAD_DATA_EVENT, {
          email: firebase.auth().currentUser.email,
          document: this.name.replace(/\s/g, "_").toLowerCase(),
        });
      } catch (err) {
        this.$vs.notify({
          title: "Error",
          text: "Please contact us using the contact form to fix this error!",
          color: "danger",
        });

        throw err;
      }
    },
    async downloadCSV() {
      if (this.url) {
        const response = await axios.get(this.url, {
          params: { resample: false, ...this.extraParams },
        });

        let data = response.data;
        // Format date to be recognized by sheets and excel as date
        data.map((item) => {
          item.date = moment(item.date).format("YYYY-MM-DD");
        });
        this.dataToJsonDownload(data);
      } else {
        this.dataToJsonDownload(this.data);
      }
    },
  },
};
</script>
